import React, { useState } from 'react';
import { Popover } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { MDSButtonProps, MDSButton, MDSIcon, MDSTypography } from '@marqvision/mds-v2';

const useStyles = makeStyles({
  wrapper: {
    marginTop: '4px',
    padding: '12px 16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    borderRadius: '8px',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
});

type Props = {
  // 팝업 내 from 자리 (화살표 왼쪽) 에 나타낼 내용
  from: string;
  // 팝업 내 to 자리 (화살표 오른쪽) 에 나타낼 내용
  to: string;
  // update 버튼 클릭 시 실행할 이벤트
  onUpdate: () => void;
  // anchor 가 되는 chip 에 표시할 텍스트
  // 전달하지 않으면 `to` 로 전달한 내용이 chipLabel 으로 출력됨
  chipLabel?: string;
} & Partial<Pick<MDSButtonProps, 'variant' | 'size' | 'color' | 'startIcon'>>;

export const UpdateListingStatusChipWithDialog = (props: Props) => {
  const { to, from, onUpdate, variant = 'border', size = 'medium', color = 'bluegray', startIcon, chipLabel } = props;
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUpdate = () => {
    onUpdate();
    handleClose();
  };

  return (
    <>
      <MDSButton variant={variant} size={size} color={color} startIcon={startIcon} onClick={handleOpen}>
        {chipLabel ?? to}
      </MDSButton>

      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handleClose}
        PaperProps={{ className: classes.wrapper }}
      >
        <div className={classes.row}>
          <MDSTypography variant="body" size="m" color="color/content/neutral/default/normal">
            {from}
          </MDSTypography>
          <MDSIcon.TailArrowDown transform="rotate(-90)" size={16} />
          <MDSTypography variant="title" size="s" weight="semibold" color="color/content/neutral/default/normal">
            {to}
          </MDSTypography>
        </div>
        <div className={classes.row}>
          <MDSButton variant="border" color="bluegray" size="medium" onClick={handleClose}>
            <MDSIcon.CloseDelete variant="outline" size={16} />
          </MDSButton>
          <MDSButton variant="fill" color="blue" size="medium" onClick={handleUpdate}>
            <MDSIcon.Check variant="outline" size={16} color="color/content/on_default_color" />
          </MDSButton>
        </div>
      </Popover>
    </>
  );
};
